import { useSelector } from 'react-redux';
import {
  ARRA_FINANCE_DEFAULT_BACK_ADDS,
  isRouteOneLender,
  ROUTE_ONE_LENDER_ID,
} from 'modules/core/constants/routeOneLenders.const';
import type { ILenderState } from 'store/reducers/lenders.reducer';
import type { RootState } from 'store/store';

const selectLender = (state: RootState): ILenderState => state.lenders.lendersHashTable[state.lenders.currentLenderId];

const selectMaxBackAdds = (state: RootState): number => state.lenders.currentLenderControls?.maxVSC || 0;

interface IArraFinanceBackAdds {
  isArraFinance: boolean;
  defaultBackAdds: number;
  dealSourceBackAdds?: number;
}

export const useArraFinanceBackAdds = (): IArraFinanceBackAdds => {
  const lender = useSelector(selectLender);
  const maxBackAdds = useSelector(selectMaxBackAdds);

  const isArraFinance = isRouteOneLender(lender?.route_one_id, ROUTE_ONE_LENDER_ID.ARRA_FINANCE);
  const dealSourceData = lender?.dealSourceData;
  const isRouteOneSession = Object.keys(dealSourceData || {}).length > 0;

  return {
    isArraFinance,
    defaultBackAdds: Math.min(ARRA_FINANCE_DEFAULT_BACK_ADDS, maxBackAdds),
    dealSourceBackAdds:
      isArraFinance && isRouteOneSession ? Math.min(dealSourceData?.finance_details?.vsc || 0, maxBackAdds) : undefined,
  };
};
